import { render, staticRenderFns } from "./copyResourceTrends.vue?vue&type=template&id=d0e16af2&"
import script from "./copyResourceTrends.vue?vue&type=script&lang=js&"
export * from "./copyResourceTrends.vue?vue&type=script&lang=js&"
import style0 from "./copyResourceTrends.vue?vue&type=style&index=0&id=d0e16af2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports